import { MinimumStockByCategoryRequest, MinimumStockByCategoryResponse, CategorizeByNameRequest, CategorizeByNameResponse, CreateProductCategoryRequest, ImportProductCategoriesRequest, ImportProductCategoriesResponse, NameRulesResponse, SaveNameRulesRequest, ProductCategoryListResponse, ProductCategorySummary, RenameProductCategoryRequest, SetProductCategoryStatusRequest, } from '@aeris/contracts';
import { request } from "./client.js";
export const fetchProductCategories = async (status, signal) => {
    const params = new URLSearchParams();
    if (status !== undefined)
        params.set('status', status);
    const query = params.toString();
    return ProductCategoryListResponse.parse(await request(`/api/v1/product-categories${query === '' ? '' : `?${query}`}`, { signal })).categories;
};
export const createProductCategory = async (input) => ProductCategorySummary.parse(await request('/api/v1/product-categories', {
    method: 'POST',
    body: CreateProductCategoryRequest.parse(input),
}));
export const setProductCategoryStatus = async (id, input) => ProductCategorySummary.parse(await request(`/api/v1/product-categories/${id}/status`, {
    method: 'POST',
    body: SetProductCategoryStatusRequest.parse(input),
}));
export const renameProductCategory = async (id, input) => ProductCategorySummary.parse(await request(`/api/v1/product-categories/${id}`, {
    method: 'PATCH',
    body: RenameProductCategoryRequest.parse(input),
}));
/**
 * Marca a categoria pelo nome: começa com / contém (F163, F272).
 *
 * `dryRun` é a prévia: o mesmo caminho, sem gravar. A tela mostra o número dela
 * antes de perguntar se pode.
 */
export const categorizeProductsByName = async (input) => CategorizeByNameResponse.parse(await request('/api/v1/product-categories/categorize-by-name', {
    method: 'POST',
    body: CategorizeByNameRequest.parse(input),
}));
/** As regras gravadas do "Classificar pelo nome" (F272), na ordem. */
export const fetchNameRules = async (signal) => NameRulesResponse.parse(await request('/api/v1/product-categories/name-rules', { signal })).rules;
/** Grava as regras sem marcar nada (F272). */
export const saveNameRules = async (rules) => NameRulesResponse.parse(await request('/api/v1/product-categories/name-rules', {
    method: 'PUT',
    body: SaveNameRulesRequest.parse({ rules }),
})).rules;
/**
 * As categorias por planilha (F243). `dryRun` é a prévia, como no "marcar pelo
 * começo do nome": o mesmo caminho, sem gravar.
 */
export const importProductCategories = async (input) => ImportProductCategoriesResponse.parse(await request('/api/v1/product-categories/import', {
    method: 'POST',
    body: ImportProductCategoriesRequest.parse(input),
}));
/** O estoque mínimo da categoria inteira (F288). `dryRun` só conta. */
export const setMinimumStockByCategory = async (input) => MinimumStockByCategoryResponse.parse(await request('/api/v1/product-categories/minimum-stock', {
    method: 'POST',
    body: MinimumStockByCategoryRequest.parse(input),
}));
//# sourceMappingURL=product-categories.js.map